import { ViewAll } from '@/assets';
import type { Route } from 'next';
import Link from 'next/link';

type ViewAllBtnProps = {
  href: Route;
  target?: '_blank' | '_self' | '_parent' | '_top';
};

export const ViewAllBtn = (props: ViewAllBtnProps) => {
  const { href, target = '_self' } = props;
  return (
    <Link href={href} target={target}>
      <div className="w-max rounded-[4px] border border-skin-stroke bg-surface-secondary px-6 py-[14px]">
        <div className="flex items-center justify-center text-brand">
          <p>View All</p>
          <ViewAll className="size-8" />
        </div>
      </div>
    </Link>
  );
};
